import React, { useState } from 'react';
// useNavigate removed because it's not used in this page
import './ContactPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function ContactPage() {
    // navigate not required here
    const [formData, setFormData] = useState({
        nom: '',
        prenom: '',
        telephone: '',
        sujet: '',
        typeProjet: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: Implémenter l'envoi du formulaire
        console.log('Formulaire soumis:', formData);
        alert('Merci pour votre message ! Nous vous répondrons dans les plus brefs délais.');
        setFormData({
            nom: '',
            prenom: '',
            telephone: '',
            sujet: '',
            typeProjet: '',
            message: ''
        });
    };

    return (
        <div className="contact-page">
            <Header />

            <div className="contact-page-wrapper">
                {/* Left Column - Information Section */}
                <div className="contact-info-section">
                    <div className="contact-info-content">
                        <h1 className="contact-main-title">
                            Contactez notre agence digitale <span className="contact-title-highlight">intelligente</span>
                        </h1>
                        
                        <div className="contact-description">
                            <p>
                                Une question, un projet, une idée ? Notre équipe, humaine et assistée par l'IA, est à votre écoute pour donner vie à vos ambitions digitales.
                            </p>
                            <p>
                                Chez Viviworks.AI, chaque projet est traité avec précision grâce à l'intelligence artificielle. L'IA nous aide à analyser vos besoins, anticiper vos performances et concevoir des stratégies sur mesure.
                            </p>
                            <p>
                                Que vous souhaitiez développer votre visibilité en ligne, créer un site web intelligent ou booster vos campagnes marketing, nous sommes prêts à vous accompagner vers le succès.
                            </p>
                        </div>

                        <h2 className="contact-coordinates-title">Nos coordonnées directes</h2>
                        
                        <div className="contact-coordinates">
                            <div className="contact-coord-item">
                                <span className="contact-coord-label">Email:</span>
                                <a href="mailto:contact@viviworks.fr" className="contact-coord-value">contact@viviworks.fr</a>
                            </div>
                            <div className="contact-coord-item">
                                <span className="contact-coord-label">Téléphone:</span>
                                <a href="tel:+33665758583" className="contact-coord-value">+33 6 65 75 85 83</a>
                            </div>
                            <div className="contact-coord-item">
                                <span className="contact-coord-label">Adresse:</span>
                                <span className="contact-coord-value">24-26 Arcadia Avenue. fin000 Londre, Royaume-Uni, N3 2JU</span>
                            </div>
                        </div>

                        <div className="contact-additional-info">
                            <p>
                                Notre équipe est disponible 7/7, 24h/24, et nos assistants IA nous permettent de traiter vos demandes rapidement et efficacement.
                            </p>
                            <p>
                                Vous pouvez également nous joindre directement par téléphone pour un échange plus personnalisé.
                            </p>
                            <p>
                                Prêt à booster votre présence digitale avec l'IA ? Parlons-en dès aujourd'hui !
                            </p>
                        </div>
                    </div>

                </div>

                {/* Right Column - Contact Form */}
                <div className="contact-form-section">
                    <form className="contact-page-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="nom">Nom*</label>
                            <input
                                type="text"
                                id="nom"
                                name="nom"
                                value={formData.nom}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="prenom">Prénom*</label>
                            <input
                                type="text"
                                id="prenom"
                                name="prenom"
                                value={formData.prenom}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="telephone">Téléphone*</label>
                            <input
                                type="tel"
                                id="telephone"
                                name="telephone"
                                value={formData.telephone}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="sujet">Sujet*</label>
                            <input
                                type="text"
                                id="sujet"
                                name="sujet"
                                value={formData.sujet}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="typeProjet">Type de projet*</label>
                            <input
                                type="text"
                                id="typeProjet"
                                name="typeProjet"
                                value={formData.typeProjet}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message*</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                rows="6"
                                required
                            ></textarea>
                        </div>

                        <button type="submit" className="contact-submit-btn">
                            Discutons de votre projet
                        </button>
                    </form>
                </div>
            </div>

            <Footer />
            <ScrollToTop />
        </div>
    );
}

export default ContactPage;

